<template>
	<section class="pc-banner-swiper" :style="{ height: calculatedHeight }">
		<swiper
			@swiper="onSwiper"
			:modules="[Autoplay, Pagination, Navigation, EffectCoverflow]"
			:slides-per-view="'auto'"
			:speed="500"
			:looped-slides="3"
			:space-between="0"
			:centered-slides="true"
			:effect="'coverflow'"
			:loop="true"
			:autoplay="{
				delay: 4000,
				disableOnInteraction: false,
			}"
			:coverflow-effect="{
				rotate: 3,
				stretch: 0,
				depth: 120,
				modifier: 1,
				slideShadows: true,
			}"
			:pagination="{
				clickable: true,
			}"
			:navigation="true"
			class="swiper"
			:style="{ height: calculatedHeight }"
		>
			<swiper-slide
				v-for="(item, index) in data"
				:key="index"
				:style="{ maxHeight: calculatedHeight }"
			>
				<article>
					<img
						class="cover"
						:src="item.pc_cover || cover_cc"
						loading="eager"
						decoding="async"
						:alt="item.name || ''"
						@click="jump(item, index)"
					/>
				</article>
			</swiper-slide>
		</swiper>
	</section>
</template>

<script setup>
import { nextTick, onActivated, onBeforeUnmount, onDeactivated, onMounted, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Autoplay, EffectCoverflow } from "swiper";

// 导入样式
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";

import { goLink } from "~/utils/common";

const calculatedHeight = ref(0);
const swiperInstance = ref(null);

const setHeight = () => {
	const ratio = 650 / 1920;
	const windowWidth = window.innerWidth;
	calculatedHeight.value = `${windowWidth * ratio}px`;
};

const onSwiper = swiper => {
	swiperInstance.value = swiper;
};

const refreshSwiperState = async () => {
	await nextTick();
	const instance = swiperInstance.value;
	if (!instance || instance.destroyed) return;
	instance.update();
	if (instance.navigation) {
		instance.navigation.destroy();
		instance.navigation.init();
		instance.navigation.update();
	}
	if (instance.autoplay) {
		instance.autoplay.start();
	}
};

const props = defineProps({
	data: {
		type: Object,
		default: () => ({}),
	},
	schannel: {
		type: String,
		default: "",
	},
	type: {
		type: String,
		default: "",
	},
});

onMounted(() => {
	setHeight();
	window.addEventListener("resize", setHeight);
	refreshSwiperState();
});

onBeforeUnmount(() => {
	window.removeEventListener("resize", setHeight);
});

onActivated(() => {
	refreshSwiperState();
});

onDeactivated(() => {
	const instance = swiperInstance.value;
	if (!instance || instance.destroyed) return;
	if (instance.autoplay) {
		instance.autoplay.stop();
	}
});

const jump = (item, index) => {
	item.dp_event_click && logEvent(item.dp_event_click);
	if (props.type == "home") logEvent(`home_banner_${index + 1}_click`);
	if (props.type == "onlinecs") logEvent(`calc_banner_${index + 1}_click`);
	if (!item.jump_url) return;
	goLink(item.jump_url, props.schannel);
};
</script>

<style lang="scss" scoped>
.pc-banner-swiper {
	min-width: 1280px;
	position: relative;
	overflow: hidden;

	.swiper {
		width: 100%;
		overflow: hidden;
		position: relative;
		top: 0;
		left: 0;
		// overflow: hidden;

		.swiper-slide {
			width: 100%;
			margin: 0 auto;
			font-size: 0;
			background-color: #fff;

			article {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.parallax-bg {
				position: relative;
				width: 100%;
				height: 100%;
			}

			.cover {
				width: 100%;
				height: 100%;
				object-fit: contain;
				cursor: pointer;
			}
		}
	}

	:deep(.swiper-pagination-bullets) {
		bottom: 24px;
	}

	:deep(.swiper-pagination-bullet) {
		transition: all 0.3s ease;
		width: 8px;
		height: 8px;
		background: #fff;
		border-radius: 50%;
		opacity: 0.2;
	}

	:deep(.swiper-pagination-bullet-active) {
		width: 20px;
		height: 8px;
		background: #fff;
		border-radius: 4px;
		opacity: 0.6;
	}
	:deep(.swiper-button-prev) {
		width: 46px;
		height: 46px;
		background: url("@/assets/images/pc/prev.png") no-repeat center;
		background-size: 100% 100%;
		left: 50px;
		top: 50%;
		transform: translateY(-50%);
	}
	:deep(.swiper-button-prev:after) {
		content: "";
	}
	:deep(.swiper-button-next) {
		width: 46px;
		height: 46px;
		background: url("@/assets/images/pc/next.png") no-repeat center;
		background-size: 100% 100%;
		right: 50px;
		top: 50%;
		transform: translateY(-50%);
	}
	:deep(.swiper-button-next:after) {
		content: "";
	}
	// :deep(.swiper-slide-prev::before),
	// :deep(.swiper-slide-next::before) {
	// 	content: "";
	// 	position: absolute;
	// 	top: 0;
	// 	left: 0;
	// 	width: 100%;
	// 	height: 100%;
	// 	background: rgba(0, 0, 0, 0.7); //半透明遮罩层
	// 	z-index: 1;
	// 	pointer-events: none; // 使遮罩层不影响点击事件
	// }
}
</style>
